import axios from "axios";

// Si REACT_APP_BACKEND_URL viene vacío (caso típico detrás de Caddy, donde
// el frontend y el backend comparten origen), usamos paths relativos: el
// navegador resolverá "/api/..." contra el mismo host:puerto desde el que se
// sirve la SPA. En desarrollo local sin proxy puede definirse a
// http://localhost:8000 y entonces se usa esa URL absoluta.
const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const BACKEND_URL = RAW_BACKEND_URL;
export const API = `${RAW_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("qv_token");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token invalid → redirect to login
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("qv_token");
        if (!path.startsWith("/login")) window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Error desconocido";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export default api;
